// extracted by mini-css-extract-plugin
export default {"dropdown":"src-components-common-Dropdown-index__dropdown--PZWYR"};